import { FacilityItem } from "@/components/rent/facility-item"
import { RadioGroup } from "@/components/ui/radio-group"
import type { FacilityWithUnitTypes } from "@/types/warehouse"

export type FacilitiesListProps = {
  facilities: FacilityWithUnitTypes[]
  isLoading?: boolean
  value: string | null
  onValueChange: (code: string) => void
}

export function FacilitiesList({
  facilities,
  isLoading = false,
  value,
  onValueChange,
}: FacilitiesListProps) {
  if (isLoading) {
    return (
      <div className="flex min-h-[92px] items-center justify-center text-sm text-light-muted">
        Загрузка складов…
      </div>
    )
  }

  if (facilities.length === 0) {
    return (
      <div className="flex min-h-[92px] items-center justify-center text-sm text-light-muted">
        Нет доступных складов для аренды
      </div>
    )
  }

  return (
    <RadioGroup value={value ?? ""} onValueChange={onValueChange} className="flex flex-col gap-2">
      {facilities.map((item) => (
        <FacilityItem key={item.facility.code} facility={item.facility} />
      ))}
    </RadioGroup>
  )
}
